import { Paper, Typography, Grid, Badge, Chip, Box } from "@mui/material";
import styles from "../../styles/common/header.module.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

type HeaderProps = {
  pageName?: string;
  pageDesc?: string;
  children?: JSX.Element;
  funded?: boolean;
  isChallengeProposal?: boolean;
  backgroundColor?: string;
};

const Header = (props: HeaderProps) => {
  return (
    <Paper square elevation={3} className={styles.container}>
      {!props.funded && props.pageDesc && (
        <>
          <Chip
            className={styles.chipUnFunded}
            icon={<CheckCircleOutlineIcon color="secondary" />}
            label={
              <Typography className={styles.chipLabel}>Not Funded</Typography>
            }
          />
          <Typography variant="h3" className={styles.typo}>
            {props.isChallengeProposal
              ? `Challenge Proposal: ${props.pageName}`
              : props.pageName}
          </Typography>
        </>
      )}

      {!props.funded && !props.pageDesc && (
        <Typography variant="h3" className={styles.typo}>
          {props.pageName}
        </Typography>
      )}

      {props.funded && (
        <>
          <Chip
            className={styles.chipFunded}
            icon={<CheckCircleIcon color="secondary" />}
            label={<Typography className={styles.chipLabel}>Funded</Typography>}
          />
          <Typography variant="h3" className={styles.typoGolden}>
            {props.isChallengeProposal
              ? `Challenge Proposal: ${props.pageName}`
              : props.pageName}
          </Typography>
        </>
      )}
      <Grid container spacing={4} className={styles.grid} direction="column">
        <Grid item>
          {!props.funded && (
            <Typography variant="body1" className={styles.typo}>
              {props.pageDesc}
            </Typography>
          )}
          {props.funded && (
            <Typography variant="body1" className={styles.typoGolden}>
              {props.pageDesc}
            </Typography>
          )}
        </Grid>

        {props.children}
      </Grid>
    </Paper>
  );
};

export default Header;
